module.exports = __webpack_public_path__ + "img/btn_back.6c8e53f6.svg";